import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { HealthCheckService } from './services/health-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {

  healthStatus = null;
  loading = true
  healthy = false

  build_date = null
  build_hash = null

  constructor(private healthCheckService: HealthCheckService) { }

  async ngOnInit() {
    this.loading = true
    const response = await this.healthCheckService.getApiHeathStatus().toPromise()
    this.healthStatus = response
    if (this.healthStatus.status === 'ok') {
      this.healthy = true
      this.build_date = this.healthStatus.build_date;
      this.build_hash = this.healthStatus.build_hash;
    } else {
      this.healthy = false
    }
  }
}
